export default "__VITE_ASSET__qkA6JgHo__"